export const File06Icon = ({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M11.6666 1.89128V5.3334C11.6666 5.80011 11.6666 6.03346 11.7575 6.21172C11.8374 6.36853 11.9649 6.49601 12.1217 6.5759C12.2999 6.66673 12.5333 6.66673 13 6.66673H16.4421M13.3333 10.8333H6.66665M13.3333 14.1667H6.66665M8.33331 7.50001H6.66665M11.6666 1.66667H7.33331C5.93318 1.66667 5.23312 1.66667 4.69834 1.93916C4.22793 2.17884 3.84548 2.56129 3.6058 3.0317C3.33331 3.56647 3.33331 4.26654 3.33331 5.66667V14.3333C3.33331 15.7335 3.33331 16.4335 3.6058 16.9683C3.84548 17.4387 4.22793 17.8212 4.69834 18.0609C5.23312 18.3333 5.93318 18.3333 7.33331 18.3333H12.6666C14.0668 18.3333 14.7668 18.3333 15.3016 18.0609C15.772 17.8212 16.1545 17.4387 16.3942 16.9683C16.6666 16.4335 16.6666 15.7335 16.6666 14.3333V6.66667L11.6666 1.66667Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={pathClassName}
    />
  </svg>
);
